<template>
  <div>
    <b-container>
      <transition name="fade">
        <ProductsList scope="ms" :total="getTotal" :selected-product-data="getProduct" :selected-product-docs="getDocs" :products="getProducts" @on-product-select="showProduct(...arguments)" @on-click-load-more="loadMore">
          <template #ingress>
            <h2 class="d-print-none">{{ products_montagestolpe_title }}</h2>
            <p class="d-print-none">{{ products_montagestolpe_text }}</p>
          </template>
        </ProductsList>
      </transition>
    </b-container>
  </div>
</template>

<script>
  import store from "@/store/store";
  import { mapGetters, mapActions } from "vuex";
  import productsListMixin from "@/mixins/productsListMixin";
  import contentMixin from "@/mixins/contentMixin";
  export default {
    name: "ProductsListViewMS",
    mixins: [productsListMixin, contentMixin],
    computed: {
      ...mapGetters("productsMS", ["getProducts", "getCount", "getTotal"]),
      ...mapGetters("productMS", ["getProduct", "getDocs"]),
    },
    methods: {
      ...mapActions("productsMS", ["fetchProducts"]),
      ...mapActions("productMS", ["fetchProduct", "fetchDocsForArt"]),
      loadMore() {
        this.$store.dispatch("productsMS/updateSkip");
      },
    },
    beforeRouteEnter(to, from, next) {
      // Reset pagination
      store.dispatch("productsMS/resetSkip");
      // Reset selected product
      store.dispatch("productMS/resetProduct");
      store
        .dispatch("productsMS/fetchProducts")
        .then(() => next())
        .catch((error) => {
          if (error.response && error.response.status == 404) {
            next({ name: "404", params: { resource: "event" } });
          } else {
            next({ name: "network-issue" });
          }
        });
    },
    beforeRouteUpdate(to, from, next) {
      store.dispatch("productsMS/fetchProducts").then(() => {
        next();
      });
    },
  };
</script>

<style lang="scss" scoped></style>
